import { register, getPrefix } from '../../../Utils'

const JobDetail = el => {
  const prefix = getPrefix(el)
  const applicationForm = el.querySelector(`.${prefix}application-form`)
  const formToggler = el.querySelector(`.${prefix}form-toggler`)

  if (applicationForm && formToggler) {
    const toggleForm = () => {
      const clientHeight = applicationForm.clientHeight
      const scrollHeight = applicationForm.scrollHeight
      const isCollapsed = !clientHeight
      const noHeightSet = !applicationForm.style.height

      applicationForm.style.height = (isCollapsed || noHeightSet ? scrollHeight : 0) + 'px'
      if (noHeightSet) return toggleForm.call(this)
    }

    formToggler.addEventListener('click', toggleForm)
  }
}

register('JobDetail', JobDetail)
